<template>
    <div class="new-cell-group">
        <template v-if="detail.type === 'custom'">
            <van-cell-group style="margin-top:20px;">
                <van-card :thumb="(detail.exchange.template && detail.exchange.template.image_url) || icon_img" style="background-color: #ffffff;">
                    <template #title>
                        <div style="font-size: 16px;" class="bold-type">{{detail.exchange.template.name || '兑换券'}}</div>
                        <div class="exchange-describe" v-if="detail.exchange.template && detail.exchange.template.describe" >{{detail.exchange.template.describe}}</div>
                    </template>
                </van-card>
            </van-cell-group>

            <van-cell-group title="兑换信息">
                <van-cell title="兑换状态"  title-class="font-size-text" :value="$store.state.systemEnum['company']['user_exchange']['status'][detail.status]"/>
                <van-cell v-if="detail.write_off_time" title="核销时间"  title-class="font-size-text" :value="detail.write_off_time"/>
                <van-cell v-if="detail.expire_time" title="过期时间"  title-class="font-size-text" :value="detail.expire_time"/>
                <van-cell v-if="detail.exchange.template && detail.exchange.template.explain" title="使用说明" title-class="font-size-text" :label="detail.exchange.template.explain" />
            </van-cell-group>
        </template>

        <template v-if="detail.type === 'goods_exchange'">
            <van-cell-group style="margin-top:20px;">
                <van-card :num="detail.detail.goods.buy_number" :thumb="detail.detail.goods.image" style="background-color: #ffffff;">
                    <template #title>
                        <div style="font-size: 16px;" class="bold-type">{{detail.detail.goods.title}}</div>
                    </template>
                </van-card>
            </van-cell-group>

            <van-cell-group title="兑换信息">
                <van-cell title="兑换状态" title-class="font-size-text" :value="$store.state.systemEnum['company']['user_exchange']['status'][detail.status]"/>
                <van-cell title="兑换时间" title-class="font-size-text" :value="detail.created_at"/>
                <van-cell title="可兑换站点" title-class="font-size-text">
                    <template #label>
                        {{canUseSite}}
                    </template>
                </van-cell>
                <van-cell v-if="detail.write_off_time" title="核销时间：" :value="detail.write_off_time"/>
                <van-cell v-if="detail.expire_time" title="过期时间：" :value="detail.expire_time"/>
            </van-cell-group>
        </template>
        <div>
            <van-cell-group style="margin-top: 10px;">
                <div :class="{ 'exchange-item' : true, 'write-off' : detail.status === '1' || detail.status === '2'   }">
                    <div class="exchange-code">
                        <span class="exchange-code-title">商品兑换码</span>
                        <span class="exchange-info" v-if="detail.expire_time">请在{{detail.expire_time}}前凭此兑换码到油站兑换商品</span>
                        <span class="exchange-code-text">{{detail.type === 'custom' && detail.exchange.template && detail.exchange.template.source === 'other_system' ? detail.code || '' : (detail.code && splitCode(detail.code)) || ''}}</span>
                    </div>
                    <div class="exchange-qrcode">
                        <qriously :value="detail.code ? detail.code: ''" :size="200" :foreground-alpha="detail.status === '1' || detail.status === '2'? 0.3 : 1" />
                    </div>
                    <div class="write-off-text">{{detail.status == 1 ? '已核销': ''}}{{detail.status == 2 ? '已过期': ''}}</div>
                </div>
            </van-cell-group>
        </div>
    </div>
</template>

<script>
    import api from "../../assets/js/api";

    export default {
        name: 'Detail',
        data () {
            return {
                detail : {
                    detail_info : {},
                },
                icon_img: require('@/assets/carwash_my.png')
            };
        },
        computed : {
            canUseSite(){
                if(!this.detail.detail_info.suit_site_info) return '';
                let site = this.detail.detail_info.suit_site_info;
                let siteArr = [];
                for(let index in site){
                    siteArr.push(site[index]['name']);
                }
                return siteArr.join('、');
            },
        },
        created() {
            console.log(this.icon_img)
            let self = this;
            api.request('/exchange/detail', {
                'id' : this.$route.query.id,
            }).then(res => {
                self.detail = res.data;
            })
            
        },
        methods : {
            splitCode(value){
                if (!value) {
                    return
                }
                let needleSplitVal = value;
                let valArr = [];
                while (needleSplitVal.length > 4){
                    valArr.push(needleSplitVal.substr(0, 4));
                    needleSplitVal = needleSplitVal.substring(4);
                }
                if(needleSplitVal){
                    valArr.push(needleSplitVal);
                }
                return valArr.join(' ');
            },
        },
    }
</script>

<style lang="scss" scoped>
@import '../../style/base.scss';
    .order-no-cell{
        .van-cell__title{
            flex: 1;
        }
        .van-cell__value{
            flex: 2;
        }
    }
    .exchange-describe {
        font-size: 14px;
        color: #999;
    }
    .exchange-item{
        width: 95%;
        padding: 30px 0;
        border-top: 1px dashed #cccccc;
        position: relative;
        background: #ffffff;
        border-radius: 0.3rem;


        &:first-child{
            border-top: none;
        }
        &.write-off{
            .exchange-code{
                .exchange-code-text{
                    color: #cccccc;
                }
            }
            .write-off-text{
                display: block;
            }
        }
        .exchange-info {
            font-size: 15px;
            text-align: center;
            display: block;
            width: 60%;
            margin: auto;
            padding: 10px;
            color: #da4242;
        }

        .exchange-code{
            font-size: 0.6rem;
            text-align: center;
            padding-bottom: 10px;

            .exchange-code-title {
                display: block;
                font-size: 0.35rem;
                margin-bottom: 0.1rem;
                color: #888;
            }
            .exchange-code-text{
                display: block;
                width: 90%;
                margin: auto;
                padding: 10px;
                color: #575757;
            }
        }
        .exchange-qrcode{
            padding: 10px;
            border: 1px solid #eeeeee;
            width: 200px;
            margin: auto;
        }

        .write-off-text{
            font-size: 30px;
            font-weight: bold;
            width: 130px;
            height: 130px;
            line-height: 130px;
            text-align: center;
            color: #767676;
            border: 5px solid #767676;
            border-radius: 1000px;
            position: absolute;
            right: 30px;
            bottom: 30px;
            transform: rotate(-30deg);
            display: none;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/exchange/Detail.vue